import { computed } from 'vue'
import { hasSandboxCleanupAccess, hasSystemAdminAccess, staffHasPermission } from '@/shared/system-admin'
import { useAuthStore } from '@/stores/auth'
import type { StaffPermission } from '@/shared/permissions'
import { normalizeStaffPermissionList } from '@/shared/staff-permission-list'

export function useStaffPermissions() {
  const auth = useAuthStore()

  const raw = computed(() => {
    const perms = auth.user?.role?.permissions
    return normalizeStaffPermissionList(perms)
  })

  function can(permission: StaffPermission): boolean {
    return staffHasPermission(auth.user, permission)
  }

  const isSuperAdmin = computed(() => raw.value.includes('*'))

  const canAccessSystem = computed(() => hasSystemAdminAccess(auth.user))

  const canCleanupSandbox = computed(() => hasSandboxCleanupAccess(auth.user))

  return { canCleanupSandbox, can, raw, isSuperAdmin, canAccessSystem, canViewRawData: canAccessSystem }
}
